/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_FixedInputs */

const en_control_planner_fixed = /** @type {(inputs: Control_Planner_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed unlock`)
};

const zh_control_planner_fixed = /** @type {(inputs: Control_Planner_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定解锁`)
};

/**
* | output |
* | --- |
* | "Fixed unlock" |
*
* @param {Control_Planner_FixedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_fixed = /** @type {((inputs?: Control_Planner_FixedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_FixedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_fixed(inputs)
	return zh_control_planner_fixed(inputs)
});
export { control_planner_fixed as "control.planner.fixed" }